import { render, staticRenderFns } from "./AddDealForm.vue?vue&type=template&id=23109ae8&scoped=true&"
import script from "./AddDealForm.vue?vue&type=script&lang=js&"
export * from "./AddDealForm.vue?vue&type=script&lang=js&"
import style0 from "./AddDealForm.vue?vue&type=style&index=0&id=23109ae8&prod&lang=scss&"
import style1 from "./AddDealForm.vue?vue&type=style&index=1&id=23109ae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23109ae8",
  null
  
)

export default component.exports